import {
    GET_ADD_ON_GROUPS_SUCCESS,
  } from "../actions/addOnGroupsActions";
  
  const initState = {
    addOnGroups: [],
  };
  
  const addOnGroupsReducer = (state = initState, action) => {
    if (action.type === GET_ADD_ON_GROUPS_SUCCESS) {
      return {
        ...state,
        addOnGroups: action.payload,
      };
    }
  
    return state;
  };
  
  export default addOnGroupsReducer;
  